const COOKIE_NAME = "pl_pending_skill_remix";
const COOKIE_DOMAIN = ".promptlayer.com";
const COOKIE_MAX_AGE_SECONDS = 3600;

export interface PendingSkillRemixPayload {
  share_token: string;
}

const isLocalhost = (): boolean => {
  if (typeof window === "undefined") {
    return false;
  }
  const { hostname } = window.location;
  return hostname === "localhost" || hostname === "127.0.0.1";
};

const getCookieAttributes = (): string => {
  if (isLocalhost()) {
    return "Path=/; SameSite=Lax";
  }
  return `Domain=${COOKIE_DOMAIN}; Path=/; Secure; SameSite=Lax`;
};

export const setPendingSkillRemixCookie = (shareToken: string): void => {
  if (typeof document === "undefined") {
    return;
  }
  const value = encodeURIComponent(
    JSON.stringify({ share_token: shareToken } satisfies PendingSkillRemixPayload),
  );
  document.cookie = `${COOKIE_NAME}=${value}; ${getCookieAttributes()}; Max-Age=${COOKIE_MAX_AGE_SECONDS}`;
};

export const readAndClearPendingSkillRemix = (): PendingSkillRemixPayload | null => {
  if (typeof document === "undefined") {
    return null;
  }
  const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${COOKIE_NAME}=([^;]*)`));
  if (!match) {
    return null;
  }

  document.cookie = `${COOKIE_NAME}=; ${getCookieAttributes()}; Max-Age=0`;

  try {
    return JSON.parse(decodeURIComponent(match[1])) as PendingSkillRemixPayload;
  } catch {
    return null;
  }
};
